<template>
  <div class="b-card-container flex-1">
    <div class="bc-header-container">
      <div class="bc-header">Home Detail</div>
    </div>
    <div v-for="(p, idx) in customerProfiles" :key="idx">
      <div class="bc-row-container">
        <div class="bc-column-container">
          <div class="bc-info-container divider-h">
            <div class="sac__font-14 med">
              {{ p.serviceAddress?.address1 || "--" }}
            </div>
            <button
              v-if="adminRole !== 'viewer'"
              class="sac__font-14 semi-bold f-primary"
              @click="setProfileEdit(p)"
            >
              Edit
            </button>
          </div>
          <div class="bc-info-container">
            <div class="sac__font-14 n70">Built In</div>
            <div class="sac__font-14">
              {{ getHomeAge(p.homeYear) }}
            </div>
          </div>
          <div class="bc-info-container">
            <div class="sac__font-14 n70">Maintenance</div>
            <div class="sac__font-14">
              {{ p.maintenance || "--" }}
            </div>
          </div>
          <div class="bc-info-container">
            <div class="sac__font-14 n70">Last Service Date</div>
            <div class="sac__font-14">
              {{ dateWithoutHour(p.lastServiceDate, dateAndYearFormat) }}
            </div>
          </div>
          <div class="bc-info-container">
            <div class="sac__font-14 n70">Explain</div>
            <div class="sac__font-14">
              {{ p.explain || "--" }}
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import customerDetailMixin from "@shared/mixins/customerDetailMixin";
import unitPreferencesMixin from "@shared/mixins/unitPreferencesMixin";

export default {
  name: "HomeDetail",
  mixins: [customerDetailMixin, unitPreferencesMixin],
  computed: {
    customerProfiles() {
      const hvacList = this.hvac || [];
      const propertyProfiles = this.propertyProfiles || [];
      const customerProfiles = [];
      if (hvacList.length && propertyProfiles.length) {
        propertyProfiles.forEach((pp) => {
          const serviceAddressId = pp?.serviceAddressId;
          const system = hvacList
            .filter((h) => h.serviceAddress?.id === serviceAddressId)
            .sort((a, b) => new Date(b.lastServiceDate) - new Date(a.lastServiceDate))[0];
          if (system) {
            customerProfiles.push({
              ...pp,
              uid: system.uid,
              customerId: system.customerId,
              corpId: system.corpId,
              lastServiceDate: system.lastServiceDate,
              serviceAddress: system.serviceAddress,
            });
          }
        });
      }
      return customerProfiles;
    },
  },
  methods: {
    setProfileEdit(profile) {
      this.$store.dispatch("changeCustomerDetailValue", {
        field: "propertyProfile",
        value: profile,
      });
      this.toggleActionModal(true, "edit-questionnaire");
    },
  },
};
</script>
